export default {
  data() {
    return {
      removeItem: null,
      removeDialog: false,
      removeLoading: false,
    };
  },
  methods: {
    onRemove(e) {
      this.removeItem = e;
      this.removeDialog = true;
    },
    async onYes() {
      this.removeLoading = true;
      const response = await this.remover(this.removeItem.uuid);
      if (response) {
        this.$refs.crud.$refs.pag.removeResult(this.removeItem);
      }
      this.removeLoading = false;
      this.removeDialog = false;
    },
  },
};
